import React, { useState } from 'react';
import useModel from '../../api/modelEdit';
import Header from './Header';
import './Model.css';

export default ({ match }) => {
  const { name, gallery } = match.params;
  const [viewSize, setViewSize] = useState(3);
  const [images, sizes, names, galleries] = useModel(name, gallery, viewSize);
  return (
    <>
      <Header
        match={match}
        sizes={sizes}
        names={names}
        galleries={galleries}
        setViewSize={setViewSize}
        viewSize={viewSize}
      />
      {images}
    </>
  );
};
